import { TableCell } from '@/components/ui/table';
import { Tooltip } from '@/components/ui/tooltip';
import { formatPercentage } from '@/utils/format/number';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type GuaranteedSOHCellProps = {
  row: UnitOverviewRow;
};

export function GuaranteedSOHCell({ row }: GuaranteedSOHCellProps) {
  return (
    <TableCell justify="left">
      {row.guaranteedSOH ? (
        row.guaranteedSOH.penalty > 0 ? (
          <Tooltip
            delay
            content="SOH adjusted by historical penalty only (excl. predictive)"
          >
            <div className="whitespace-nowrap">
              <span className="whitespace-nowrap font-semibold underline">
                {formatPercentage(row.guaranteedSOH.effective, 0, 5)}
              </span>
              {row.guaranteedSOH.penalty >= 0.01 ? (
                <span className="ml-2 whitespace-nowrap text-sm font-semibold text-red-600">
                  (-
                  {formatPercentage(row.guaranteedSOH.penalty, 0, 5)})
                </span>
              ) : null}
            </div>
          </Tooltip>
        ) : (
          <span className="whitespace-nowrap">
            {formatPercentage(row.guaranteedSOH.effective, 0, 5)}
          </span>
        )
      ) : (
        '-'
      )}
    </TableCell>
  );
}
